import React from "react";
import {
  getBreakPoint,
  icons,
  UI_BODY_SEMIBOLD_SM,
  useScreenWidth,
  colors2,
  TabBarV2,
} from "oolib";

import { StyledActionBar, StyledSortButton, StyledSortButtonWrapper } from "../styled";

import {
  LEFT_RIGHT_PADDING,
  LEFT_RIGHT_PADDING_V2,
  DESKTOP_SIDEBAR_WIDTH,
  MOBILE_SIDEBAR_WIDTH,
} from "../../Shell";
import { Sort } from "./Sort";
import { Search } from "./Search";
import { FilterModuleHeader } from "../../Shell/comps/FiltersSidebarShell/comps/FilterModuleHeader";
import { ButtonGhost } from "oolib/dist/v2/components/Buttons";
import { LAYOUT_CONSTANTS } from "@/_self_managed/LAYOUT_CONSTANTS";
import { useShowFilterModuleV3 } from "@/components/discovery/FilterModule/hooks/useShowFilterModuleV3";

const { Funnel, SortDescending } = icons;

export const DesktopPanel = ({
  filtersExist,
  showSearchInput,
  showSortDropdown,
  activeSort,
  setActiveSort,
  sortConfig,
  showSideBarLeft,
  setShowSideBarLeft,
  searchTermInputText,
  handleSearch,
  enableListingStyleSwitcher,
  listingStyle,
  setListingStyle,
  setAddFilterAnchorEl,
  setAddFilterOpen,
  clearFilters,
  hasFiltersToClear,
  activeFiltersCount,
  activeFilters,
}) => {
  const screenWidth = useScreenWidth();
  const { showFilterModuleV3 } = useShowFilterModuleV3();

  const isMobile = screenWidth <= getBreakPoint("sm");
  const SIDEBAR_WIDTH = isMobile ? MOBILE_SIDEBAR_WIDTH : DESKTOP_SIDEBAR_WIDTH;
  return (
    <StyledActionBar $reducedPadding={showFilterModuleV3}>
      {filtersExist && (
        <FilterModuleHeader
          style={{
            ...(showFilterModuleV3 ? { paddingRight: showSideBarLeft ? "0.6rem" : "1.6rem" } : { paddingRight: "2rem" }),
          }}
          showSideBarLeft={showSideBarLeft}
          width={
            !showSideBarLeft
              ? "max-content"
              : showFilterModuleV3 ? SIDEBAR_WIDTH - LEFT_RIGHT_PADDING_V2 : SIDEBAR_WIDTH - LEFT_RIGHT_PADDING
          }
          onOpen={() => !showSideBarLeft && setShowSideBarLeft(true)}
          onClose={() => setShowSideBarLeft(false)}
          setAddFilterAnchorEl={setAddFilterAnchorEl}
          setAddFilterOpen={setAddFilterOpen}
          clearFilters={clearFilters}
          hasFiltersToClear={hasFiltersToClear}
          activeFiltersCount={activeFiltersCount}
          activeFilters={activeFilters}
        />
      )}

      <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
        {showSearchInput && (
          <Search
            isMobile={false}
            handleSearch={handleSearch}
            searchTermInputText={searchTermInputText}
          />
        )}
        {showSortDropdown && (
          <Sort
            {...{
              sortConfig,
              activeSort,
              setActiveSort,
              genCustomSelectComp: () => (
                <StyledSortButtonWrapper>
                  <StyledSortButton>
                    <SortDescending
                      style={{ color: colors2.grey80 }}
                      size={16}
                      weight="bold"
                    />
                    <UI_BODY_SEMIBOLD_SM
                      style={{ color: colors2.grey80 }}
                    >{`Sort by: ${activeSort.display}`}</UI_BODY_SEMIBOLD_SM>
                  </StyledSortButton>
                </StyledSortButtonWrapper>
              ),
            }}
          />
        )}
        {enableListingStyleSwitcher && (
          <div
            style={{
              height: "100%",
              display: "flex",
              alignItems: "center",
              gap: "2px",
              ...(showSortDropdown
                ? {
                  borderLeft: `1px solid ${colors2.grey10}`,
                  paddingLeft: LAYOUT_CONSTANTS.pagePadding + "px",
                }
                : showSearchInput
                ? {
                  paddingLeft: LAYOUT_CONSTANTS.pagePadding + "px",
                }
                : {
                  paddingLeft: 0,
                }),
            }}
          >
            <TabBarV2
              options={[
                { icon: "Table", value: "TableStyle" },
                { icon: "Cards", value: "CardsStyle" },
                { icon: "ListDashes", value: "ListStyle" },
              ]}
              saveValueAsString
              value={listingStyle}
              onChange={(k, v) => setListingStyle(v)}
            />
          </div>
        )}
      </div>
    </StyledActionBar>
  );
};
